import { Loader } from '@googlemaps/js-api-loader';

/**
 * Google Map
 * ======================================
 * <div class="map js-map" data-lat="49.84306953594377" data-lng="14.525088870187364"></div>
 * https://developers.google.com/maps/documentation/javascript/tutorial
 *
 */

const API_KEY = 'AIzaSyCZ23Jp8aW0OJZLC1CNqz2mwBoeHRqkmGs'
const WIDGET = '.js-map'

class Map {
	constructor() {
    this.element = document.querySelector(WIDGET)

    if (!this.element) {
			return false
    }

    this.lat = parseFloat(this.element.getAttribute('data-lat'))
    this.lng = parseFloat(this.element.getAttribute('data-lng'))
    this.zoom = parseFloat(this.element.getAttribute('data-zoom'))
    this.marker = 'images/marker.svg'
    this.mapOptions = {
			zoom: this.zoom,
			center: { lat: this.lat, lng: this.lng },
			disableDefaultUI: true,
			zoomControl: true,
			scrollwheel: false
    }

		if (!this.lat || !this.lng) {
			return false
    }

    const loader = new Loader({
      apiKey: API_KEY,
      version: "weekly"
    });

    loader.load().then(() => {
      this.initMap()
    })
    .catch(e => {
      console.log('Mapu nelze načíst.', e)
    });
  }

  initMap = () => {
    const map = new google.maps.Map(this.element, this.mapOptions)

		const iconSvg = {
			url: '/app/themes/ipress/build/'+this.marker,
			scaledSize: new google.maps.Size(30, 36)
		}

		if (typeof markers !== 'undefined') {
			markers.forEach(item => {
				const marker = new google.maps.Marker({
					icon: iconSvg,
					optimized: false,
					title: item.title,
					position: { lat: item.lat, lng: item.lng }
				})

        const infowindow = new google.maps.InfoWindow({
          content: item.title,
        });

        marker.addListener("click", () => {
          infowindow.open({
            anchor: marker,
            map,
          });
        });

				marker.setMap(map)
			})
		} else {
      const marker = new google.maps.Marker({
        icon: iconSvg,
        optimized: false,
        position: { lat: this.lat, lng: this.lng }
      })
      marker.setMap(map)
    }
  }
}

new Map()

